import React, { useState } from 'react';
import { Menu, X, Phone, MapPin } from 'lucide-react';
import { restaurantInfo } from '../mockData';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm shadow-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <div className="flex items-center">
            <h1 
              className="text-2xl md:text-3xl font-bold cursor-pointer" 
              style={{ fontFamily: 'var(--font-serif)', color: 'var(--color-black)' }}
              onClick={() => scrollToSection('hero')}
            >
              AURA
            </h1>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button onClick={() => scrollToSection('about')} className="nav-link">About</button>
            <button onClick={() => scrollToSection('menu')} className="nav-link">Menu</button>
            <button onClick={() => scrollToSection('gallery')} className="nav-link">Gallery</button>
            <button onClick={() => scrollToSection('reviews')} className="nav-link">Reviews</button>
            <button onClick={() => scrollToSection('contact')} className="nav-link">Contact</button>
          </nav>

          {/* Contact Info - Desktop */}
          <div className="hidden lg:flex items-center space-x-4">
            <a href={`tel:${restaurantInfo.phone}`} className="flex items-center text-sm hover:opacity-70 transition-opacity">
              <Phone size={16} className="mr-2" />
              {restaurantInfo.phone}
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden p-2"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="md:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col space-y-4">
              <button onClick={() => scrollToSection('about')} className="mobile-nav-link">About</button>
              <button onClick={() => scrollToSection('menu')} className="mobile-nav-link">Menu</button>
              <button onClick={() => scrollToSection('gallery')} className="mobile-nav-link">Gallery</button>
              <button onClick={() => scrollToSection('reviews')} className="mobile-nav-link">Reviews</button>
              <button onClick={() => scrollToSection('contact')} className="mobile-nav-link">Contact</button>
              <a href={`tel:${restaurantInfo.phone}`} className="mobile-nav-link flex items-center">
                <Phone size={16} className="mr-2" />
                {restaurantInfo.phone}
              </a>
            </div>
          </nav>
        )}
      </div>

      <style jsx>{`
        .nav-link {
          font-weight: 500;
          color: var(--color-black);
          transition: opacity 0.2s ease;
          background: none;
          border: none;
          cursor: pointer;
          font-size: 16px;
        }

        .nav-link:hover {
          opacity: 0.7;
        }

        .mobile-nav-link {
          font-weight: 500;
          color: var(--color-black);
          transition: opacity 0.2s ease;
          background: none;
          border: none;
          cursor: pointer;
          font-size: 16px;
          text-align: left;
          padding: 8px 0;
        }

        .mobile-nav-link:hover {
          opacity: 0.7;
        }
      `}</style>
    </header>
  );
};

export default Header;
